// Contract signing — shared vocabulary for the admin sections, My events and the
// public signing page. Deliberately imports nothing that needs the signed-in app
// (no axios), so the public page can use it too.
import { API_BASE_URL } from "./config";

export const CONTRACTS_API = `${API_BASE_URL}/contracts`;
export const PUBLIC_SIGNING_API = `${API_BASE_URL}/contract-signing`;

// Mirrors ContractRequest.status in backend/app/contracts/models.py.
export const CONTRACT_STATUS = {
  draft: { label: "Draft — not sent", color: "default" },
  sent: { label: "Awaiting signature", color: "warning" },
  signed: { label: "Signed — finishing", color: "info" },
  completed: { label: "Signed by both", color: "success" },
  voided: { label: "Voided", color: "default" },
};

// A contract still in progress — at most one of these per attendance, and per
// event for an organiser's agreement.
export const ACTIVE_CONTRACT_STATUSES = ["draft", "sent", "signed"];

// Attendance statuses for which a bulk send offers someone. Available isn't a
// booking, and No Contract Needed says so.
export const CONTRACTABLE_ATTENDANCE_STATUSES = ["Selected", "Contract Sent"];

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
};

export const signatureFor = (doc, party) =>
  (doc?.signatures || []).find(s => s.party === party) || null;

// Where to ask for a short-lived named link to one of a document's files.
export const contractLinkUrl = (contract, doc) =>
  `${CONTRACTS_API}/${contract.id}/documents/${doc.id}/link`;
